import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'htmlTemplateRender',
})

export class HtmlTemplateRenderPipe implements PipeTransform {
  constructor(private sanitizer:DomSanitizer){}
  
  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/html-template-render/html-template-render.ts